import { default as display } from './display.svelte'


export default{ display }
